export default __webpack_public_path__ + "static/media/foreal_vs_louisville.ce46dec7.jpg";